<template>
  <div class="fill-height">
    <v-sheet
      color="light"
      tile
      class="fill-height"
    >
      <v-row
        no-gutters
      >
        <v-col>
          <v-container
            fluid
            class="px-0 px-sm-6"
          >
            <v-row>
              <v-col
                cols="6"
                :class="!isDesktop && 'pb-0'"
              >
                <p
                  class="title-text"
                >
                  {{ firstName }}, {{ topText }}
                </p>
              </v-col>
              <v-col class="end">
                <v-btn
                  rounded
                  depressed
                  color="white"
                  small
                  class="mb-2"
                  @click="onCloseDrawer"
                >
                  <v-icon
                    color="primary"
                    class="mr-1"
                  >
                    mdi-close-circle
                  </v-icon>
                  <span class="primary--text text-decoration-underline">Close</span>
                </v-btn>
              </v-col>
            </v-row>

            <v-row :class="!isDesktop && 'mt-0'">
              <v-col
                v-if="!isDesktop"
                cols="4"
                class="pt-0 flex-display"
              >
                <img
                  v-if="isSameCompany"
                  :src="image"
                  :alt="brokerName"
                  class="center"
                >
              </v-col>
            </v-row>

            <v-row>
              <v-col
                :class="!isDesktop && 'pt-0 pb-0'"
              >
                <help-text
                  class="help-text"
                >
                  <p v-html="helpText" />
                </help-text>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col
                class="font-weight-medium"
                :class="!isDesktop && 'pt-0 pb-0'"
              >
                <slot name="main" />
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import HelpText from '@/components/HelpText/HelpText.vue';
export default {
  name: 'options-layout',
  components: {
    HelpText,
  },
  props: {
    coverBoostTitleMessage: {
      type: String,
      default: '',
    },
    brokerName: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
    isSameCompany: {
      type: Boolean,
      default: true,
    },
    isDesktop: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    topText () {
      return this.isSameCompany
        ? 'just before you continue...'
        : 'some other options to consider...';
    },
    helpText () {
      if (this.coverBoostTitleMessage?.length) return this.coverBoostTitleMessage;
      return this.isSameCompany
        ? `Based on your selection with <b>${this.brokerName}</b>, our system has found some Cover Boost options for you.`
        : `Just in case you missed it, based on your chosen policy with <b>${this.brokerName}</b>, our system has found some other value options for you.`;
    },
  },
  methods: {
    onCloseDrawer () {
      this.$emit('close-drawer');
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-display {
  display: flex;
}

.center {
  align-self: center;
}

.end {
  text-align: end;
}

.title-text {
  color: rgba(71, 127, 210, 1);
  font-weight: bold;
  font-size: 16px;
}

.help-text {
  padding: 20px 28px;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
}
</style>
